import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {UserDataService} from '../user-data.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages: string;
    errorResp: string;


    constructor(private loginService: UserDataService,
                private router: Router,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.loginService.getMainData()
            .subscribe(user => {
                if (user) {
                    this.router.navigate(['/cont']);
                }
            });
    }

    onSubmit(form: NgForm) {

        this.formHasBeenSend = false;

        // Form Value
        const email = form.value.email;

        this.loginService.sendResetUserPassword(email).subscribe(resData => {
            this.serverResp = true;
            this.formHasBeenSend = true;
            this.formSuccessfulSend = true;
            this.redirectUser();

        }, error => {

            this.serverResp = false;
            this.formHasBeenSend = true;

            // Store error reason and show a message
            this.errorResp = error.error.reason;
            if (this.errorResp === 'emailNotFound') {
                this.serverErrorMessages = 'Nu exista niciun cont cu acest email.';
            } else {
                this.serverErrorMessages = 'Ceva nu a functionat corect. Te rugam sa mai incerci o data.';
            }
        });
    }

    // Redirect user after a few seconds
    redirectUser() {
        setTimeout(() => {
            this.router.navigate(['/resetare-parola']);
        }, 4000);
    }
}
